const siteData = {
  brand: {
    name: "Musa Institute for Academic and Skills Development",
    shortName: "MIASD",
    logoSrc: "./logo.png",
    logoRemovebgSrc: "./logo.png",
    description:
      "Empowering students with cutting-edge knowledge and skills in scientific disciplines. We offer hands-on training, expert guidance, and a commitment to excellence. Join us to advance your understanding and career in the world of science.",
  },

  author: {
    name: "Muhammad Majid",
    fabookLink: "https://facebook.com/majid.qau.iub/",
  },
  siteInfo: {
    email: "majid.qauiub@gmail.com",
    phone: "+92-306-7728788",
    address:
      "Musa Institute for Academic and Skills Development, Khairpur Tamewali (63060) , Bahawalpur, Punjab, Pakistan.",
    socialMediaLinks: {
      facebook: "https://facebook.com",
      instagram: "https://instagram.com",
      linkedin: "https://linkedin.com",
      twitter: "https://twitter.com",
    },
  },
  newsletter: {
    description:
      "Don’t miss out on thousands of exciting courses and educational opportunities at Musa Institute for Academic and Skills Development.",
  },
  navSection: [
    {
      title: "About",
      links: [
        { href: "/about", label: "About Us" },
        { href: "/contact", label: "Contact Us" },
        { href: "/faq", label: "FAQ" },
      ],
    },
    {
      title: "Help & Guide",
      links: [
        { href: "/terms-of-use", label: "Terms Of Use" },
        { href: "/privacy-policy", label: "Privacy Policy" },
      ],
    },
  ],
};

export default siteData;
